
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/la-liga/jugadores-dudas",
      function () {
        return require("private-next-pages/la-liga/jugadores-dudas.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/la-liga/jugadores-dudas"])
      });
    }
  